import Swiper, { Navigation, Pagination } from 'swiper'

document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    loop: true,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    simulateTouch: true,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 10
      }
    }
  })
})
